/**
 * External dependencies
 */
import styled from 'styled-components';

/**
 * Internal dependencies
 */
import StoryPropTypes from '../../types';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  border-radius: ${({ theme }) => theme.borders.radius.small};
  background-color: ${({ theme }) => theme.colors.opacity.black10};
  overflow: hidden;
`;

const PreviewImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Placeholder = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.opacity.white16};
  color: ${({ theme }) => theme.colors.fg.primary};
  font-family: ${({ theme }) => theme.typography.family.primary};
  font-size: 12px;
  line-height: 20px;
`;

function LottieLayerIcon({ element }) {
  const { previewImageUrl, title } = element;

  return (
    <Container>
      {previewImageUrl ? (
        <PreviewImage src={previewImageUrl} alt={title || ''} />
      ) : (
        <Placeholder>L</Placeholder>
      )}
    </Container>
  );
}

LottieLayerIcon.propTypes = {
  element: StoryPropTypes.elements.lottie.isRequired,
};

export default LottieLayerIcon;
